export default function abbreviateArticleCountries(countries) {
	return countries.length === 0 || countries[0] === "WORLD"
		? "World"
		: countries.slice(0, 3).join(", ") + (countries.length > 3 ? ` +${countries.length - 3}` : "");
}
